import { graphql, useStaticQuery } from "gatsby";
import React from "react";
import ExternalLink from "./ExternalLink";
import NavLinkItems from "./NavLinkItems";

const STATIC_QUERY = graphql`
  query NavQuery {
    home {
      externalLinks {
        id
        title
        url
      }
    }
  }
`;

export default function Nav({ hardcodedLinks, isResponsive, absolutePath }) {
  const data = useStaticQuery(STATIC_QUERY);
  const { externalLinks } = data.home;
  const ulClass = isResponsive
    ? "navIsResponsive absolute top-0 right-0 block w-4/5 p-10 font-bold md:w-2/5 text-md sm:text-xl lg:static lg:w-full lg:p-0 lg:flex lg:justify-evenly lg:items-center"
    : "absolute top-0 right-0 block w-4/5 p-10 md:w-2/5 text-md sm:text-xl";

  return (
    <nav>
      <ul className={ulClass} id="nav-list">
        <NavLinkItems
          hardcodedLinks={hardcodedLinks}
          isResponsive={isResponsive}
          absolutePath={absolutePath}
        />
        {(externalLinks || []).map((link) => (
          <li key={link.id}>
            <ExternalLink
              className="block py-2"
              href={link.url}
              title={link.title}
            >
              {link.title}
            </ExternalLink>
          </li>
        ))}
      </ul>
    </nav>
  );
}
